import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EDITOR_TYPE } from '../messageCreators';
import { loadChatbotStartChat } from '../thunks/chatbotStartChat.thunk';
import { fetchSites } from '../thunks/sites.thunk';

export interface ISiteItem {
  id: string;
  name: string;
  thumbnail: string;
  updatedAt: string;
  url: string;
  editorType: EDITOR_TYPE;
}

interface SitesState {
  sites: ISiteItem[];
  selectedSite: ISiteItem | null;
  copilotMetaSiteId: string | null;
  isLoading: boolean;
  hasError: boolean;
  hasFetched: boolean;
}

const initialState: SitesState = {
  sites: [],
  selectedSite: null,
  copilotMetaSiteId: null,
  isLoading: false,
  hasError: false,
  hasFetched: false,
};

export const sitesSlice = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    selectSite: (state, action: PayloadAction<ISiteItem>) => {
      state.selectedSite = action.payload;
    },
    setCopilotMetaSiteId: (state, action: PayloadAction<string>) => {
      state.copilotMetaSiteId = action.payload;
      if (state.sites.length > 0) {
        const site = state.sites.find((s) => s.id === action.payload);
        if (site) {
          state.selectedSite = site;
        }
      }
    },
    clearSelection: (state) => {
      state.selectedSite = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSites.pending, (state) => {
      state.isLoading = true;
      state.hasError = false;
    });
    builder.addCase(fetchSites.fulfilled, (state, action) => {
      state.sites = action.payload.sites;
      state.selectedSite = action.payload.selectedSite;
      state.isLoading = false;
      state.hasFetched = true;
    });
    builder.addCase(fetchSites.rejected, (state) => {
      state.isLoading = false;
      state.hasError = true;
      state.hasFetched = true;
    });
    builder.addCase(loadChatbotStartChat.fulfilled, (state, action) => {
      const metaSiteId = action.payload.startChatData?.metaSiteId;
      const hasActiveChat = action.payload.messages?.length > 0;
      if (metaSiteId && hasActiveChat && state.sites.length > 0) {
        const site = state.sites.find((s) => s.id === metaSiteId);
        if (site) {
          state.selectedSite = site;
        }
      }
    });
  },
});
